export const UI_LANGUAGE = 'rnw_ui_language'
export const ALLOWED_COOKIES = 'CookieConsent'
export const UI_THEME = 'rnw_ui_theme'
export const UI_SIDEBAR_THEME = 'rnw_ui_sidebar_theme'
export const UI_USE_SYSTEM_THEME = 'rnw_ui_use_system_theme'
